<template lang="html">
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-md-10">
        <div
          class="row justify-content-center text-center"
          :class="{disabled: !this.$store.state.appLoaded}"
        >
          <div class="col-md-12">
            <h3 class="pt-3 pb-3">
              How would you like to fundraise?
            </h3>
          </div>
          <Loader
            v-if="!this.$store.state.appLoaded"
            :show="true"
          />
          <!-- Mobile view -->
          <router-link
            v-show="AuthenticationRouterTeamId"
            :class="['square_dashboard col-12 mt-4', ($store.state.data_params_pre.teamId != '') ? '' : 'none_params' ]"
            :to="{ name: 'charity_individual', params: {} }"
            tag="div"
          >
            <div
              class="row d-md-none d-block d-sm-block mx-1 card_box"
              @click="setPageType('individual')"
            >
              <div class="card border-0 panel_box_gf">
                <div class="row">
                  <div class="col-5 box_individual py-4 mx-0">
                    <div class="gf_icon_team_db icon_individual" />
                  </div>
                  <div class="col-7 align-self-center">
                    <div class="card-block">
                      <p class="card-text mobile-title-text">
                        Create an <br>individual page
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <router-link
            v-show="AuthenticationRouterTeamId"
            :class="['square_dashboard col-12 mt-4 mx-0', ($store.state.data_params_pre.teamId != '') ? '' : 'none_params' ]"
            :to="{ name: 'charity_team', params: {} }"
            tag="div"
          >
            <div
              class="row d-md-none d-block d-sm-block mx-1 card_box"
              @click="setPageType('createTeam')"
            >
              <div class="card border-0 panel_box_gf">
                <div class="row">
                  <div class="col-5 box_team py-4">
                    <div class="gf_icon_team_db icon_team" />
                  </div>
                  <div class="col-7 align-self-center">
                    <div class="card-block">
                      <p class="card-text mobile-title-text">
                        Create a <br>team page
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <router-link
            :class="['square_dashboard col-12 mt-4 mx-0', ($store.state.data_params_pre.teamId != '') ? 'm-auto' : 'none_params' ]"
            :to="{ name: 'select_team', params: {} }"
            tag="div"
          >
            <div
              class="row d-md-none d-block d-sm-block mx-1 card_box"
              @click="setPageType('joinTeam')"
            >
              <div class="card border-0 panel_box_gf">
                <div class="row">
                  <div class="col-5 box_jointeam py-4">
                    <div class="gf_icon_team_db icon_jointeam" />
                  </div>
                  <div class="col-7 align-self-center">
                    <div class="card-block">
                      <p class="card-text mobile-title-text">
                        join an <br>existing team
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>

          <!-- Tablet/Desktop view -->
          <div class="col-md-12">
            <div class="row">
              <router-link
                v-show="AuthenticationRouterTeamId"
                :class="['square_dashboard col-md-4', ($store.state.data_params_pre.teamId != '') ? '' : 'none_params' ]"
                :to="{ name: 'charity_individual', params: {} }"
                tag="div"
              >
                <div
                  class="content col d-none d-sm-none d-md-block"
                  @click="setPageType('individual')"
                >
                  <div class="table">
                    <div class="table-cell">
                      <div class="gf-driver-button-hollow-no-border panel panel-default p-3 rounded panel_box_gf box_individual">
                        <div class="panel-heading">
                          <div class="gf_icon_team_db icon_individual" />
                        </div>
                        <div class="panel-body">
                          <p class="font-weight-bold mt-3">
                            CREATE AN<br> INDIVIDUAL PAGE
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>

              <router-link
                v-show="AuthenticationRouterTeamId"
                :class="['square_dashboard col-md-4', ($store.state.data_params_pre.teamId != '') ? '' : 'none_params' ]"
                :to="{ name: 'charity_team', params: {} }"
                tag="div"
              >
                <div
                  class="content col d-none d-sm-none d-md-block"
                  @click="setPageType('createTeam')"
                >
                  <div class="table">
                    <div class="table-cell">
                      <div class="gf-driver-button-hollow-no-border panel panel-default p-3 rounded panel_box_gf box_team">
                        <div class="panel-heading">
                          <div class="gf_icon_team_db icon_team" />
                        </div>
                        <div class="panel-body">
                          <p class="font-weight-bold mt-3">
                            CREATE A<br> TEAM
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>

              <router-link
                :class="['square_dashboard col-md-4', ($store.state.data_params_pre.teamId != '') ? 'm-auto' : 'none_params' ]"
                :to="{ name: 'select_team', params: {} }"
                tag="div"
              >
                <div
                  class="content col d-none d-sm-none d-md-block"
                  @click="setPageType('joinTeam')"
                >
                  <div class="table">
                    <div class="table-cell">
                      <div class="gf-driver-button-hollow-no-border panel panel-default p-3 rounded panel_box_gf box_jointeam">
                        <div class="panel-heading">
                          <div class="gf_icon_team_db icon_jointeam" />
                        </div>
                        <div class="panel-body">
                          <p class="font-weight-bold mt-3">
                            JOIN AN<br> EXISTING TEAM
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Loader from './components/inc/Loader.vue';
import GfAnalyticsMixin from './components/inc/GfAnalyticsMixin.vue';

export default {
  components: {Loader},
  mixins: [GfAnalyticsMixin],
  computed:{
    AuthenticationRouterTeamId:{
      get: function(){
        if(this.$store.state.data_params_pre.teamId != ''){
          return false
        }
        return true
      }
    }
  },
  
  methods: {
    setPageType: function(type) {   
      var createType = this.getCreateType(type);   
      this.analytics({
        'event': 'create_page',
        'createType': createType, 
        'stepNumber':  type == "joinTeam"? '1 of 3' : '1 of 4',
        'stepName': 'select page type'
      });
      this.$store.commit("setCreateType", createType);
      this.$store.commit('setPageType', type);
    },

    getCreateType(type){
      var createType = '';
      if(type == "joinTeam") {
        createType = "team_member";
      }
      else if(type == "createTeam"){
        createType = "team";
      }
      else {
        createType = type;
      }
      return createType;
    }
  }
}
</script>

<style scoped>

.disabled
{
  pointer-events: none;
  opacity: 0.7;
}

.mobile-title-text {
  font-family: 'bariolbold';
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 1em;
  color: #1b3949;
}

.card img{
  background-color: #F4F9FC;
}

h3 {
  font-family: 'bariolbold';
  color: #1b3949;
}

div.panel-body p {
  font-family: "bariolbold";
  letter-spacing: 2px;
}

.gf_icon_team_db{
  padding-bottom: 70%;
  position: relative;
}
.gf_icon_team_db:before{
  content: '';
  display: block;
  background-size: 68%;
  position: absolute;
  background-position: center;
  width: 70%;
  height: 100%;
  background-repeat: no-repeat;
  width:100%;
}

.box_individual:hover .icon_individual:before{
  background-image: url('assets/img/individual.png');
}
.box_team:hover .icon_team:before{
  background-image: url('assets/img/join-team.png');
}
.box_jointeam:hover .icon_jointeam:before{
  background-image: url('assets/img/team.png');
}

.icon_individual:before{
  background-image: url('https://cdn.gofundraise.com/all/media/individual.png');
}
.icon_team:before{
  background-image: url('https://cdn.gofundraise.com/all/media/join-team.png');
}
.icon_jointeam:before{
  background-image: url('https://cdn.gofundraise.com/all/media/team.png');
}

.square_dashboard {
  position: relative;
  width: 30%;
  overflow:hidden;
}
.square_dashboard .content {
  height:100%;
  width:100%;
  left: 0;
}
.square_dashboard .table{
  display:table;
  width:100%;
  height:100%;
}
.square_dashboard .table-cell{
  display:table-cell;
  vertical-align:middle;
}

.panel_box_gf{
  background-color: #F4F9FC;
}
.panel_box_gf a{
  color:#333;
}
.panel_box_gf a:hover{
  color:#fff;
}
.panel_box_gf a:hover{
  text-decoration: none;
}
.panel_box_gf .panel-heading img{
  width: 90%;
  height:120px;
  margin-bottom: 14px;
}
.panel_box_gf .panel-body p{
  font-size: 14px;
}
.panel_box_gf:hover a{
  color:#fff;
}
</style>
